import { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Input,
  InputGroup,
  InputGroupText,
  Row,
  Spinner,
} from "reactstrap";
import Image from "next/image";
import Link from "next/link";
import ReactPaginate from "react-paginate";
//local imports
import classes from "@/styles/carriers/carrier-main.module.css";
import { carriers } from "@/utils/content";
import carriersData from "@/data/carriers.json";
import {
  AiOutlineCaretLeft,
  AiOutlineCaretRight,
  AiOutlineSearch,
} from "react-icons/ai";
import { useIsMobile } from "@/hooks/useIsMobile";

export default function CarrierMain() {
  const content = carriers.en;
  const isMobile = useIsMobile();

  const [search, setSearch] = useState("");

  const [carriersFilterData, setCarriersFilterData] = useState<any>([]);

  useEffect(() => {
    setCarriersFilterData(carriersData);
  }, []);

  const onChange = (e: any) => {
    setPageNumber(1);
    const text = e.target.value.split(" ");
    setSearch(e.target.value);
    if (e.target.value.length === 0) {
      setCarriersFilterData(carriersData);
    } else {
      const newCrs = carriersData.filter((i: any) => {
        return text.every((el: any) => {
          return i.name.toLowerCase().includes(el);
        });
      });
      setCarriersFilterData(newCrs);
    }
  };

  //pagination
  const itemsPerPage = 32;
  const [pageNumber, setPageNumber] = useState(1);
  const pageCount = Math.ceil(carriersFilterData.length / itemsPerPage);
  const handlePageClick = (event: any) => {
    setPageNumber(event.selected + 1);
  };

  return (
    <>
      <section className={`${classes.head}`}>
        <div className="container">
          <h1>{content.title}</h1>
          <p>{content.para}</p>
        </div>
      </section>
      <section className="my-5">
        <div className="container">
          <form className={isMobile ? "w-100" : "w-25"}>
            <InputGroup className="border rounded">
              <Input
                className="border-0"
                type="text"
                placeholder={content.searchInputPlaceholder}
                name={search}
                onChange={onChange}
              />
              <InputGroupText>
                <AiOutlineSearch />
              </InputGroupText>
            </InputGroup>
          </form>
        </div>
      </section>
      <section className="my-5">
        <div className={`container ${classes.cardSection}`}>
          {!carriersFilterData ? (
            <Spinner
              className="m-auto"
              animation="border"
              role="status"
            ></Spinner>
          ) : (
            <Row>
              {carriersFilterData
                .slice(
                  (pageNumber - 1) * itemsPerPage,
                  pageNumber * itemsPerPage
                )
                .map((c: any, i: number) => {
                  return (
                    <Col xs={12} sm={6} md={4} lg={3} key={i}>
                      <Link
                        className={classes.link}
                        href={`/carriers/${c.slug}`}
                      >
                        <Card className={`my-2 ${classes.card}`}>
                          <CardBody className={classes.cardGrid}>
                            <Image
                              src={c.logoPath}
                              alt={c.name}
                              height={65}
                              width={65}
                            />
                            <div className="d-flex align-items-center">
                              <p className="ms-2 mt-2 text-secondary">
                                {c.name}
                              </p>
                            </div>
                          </CardBody>
                        </Card>
                      </Link>
                    </Col>
                  );
                })}
            </Row>
          )}
          <div className="my-5">
            <ReactPaginate
              className={classes.pagination}
              breakLabel="..."
              nextLabel={<AiOutlineCaretRight />}
              pageClassName="nav-link"
              pageLinkClassName="nav-link"
              previousClassName="nav-link"
              previousLinkClassName="nav-link"
              nextClassName="nav-link"
              nextLinkClassName="nav-link"
              breakClassName="nav-link"
              breakLinkClassName="nav-link"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={pageCount}
              previousLabel={<AiOutlineCaretLeft />}
            />
          </div>
        </div>
      </section>
      <section className={`mt-5 pt-5 pb-5 ${classes.footer}`}>
        <div className="container text-center">
          <p className="m-0 pt-5 pb-5">
            {content.footerText}&nbsp;
            <a className={classes.link} href={`mailto:${content.email}`}>
              {content.email}
            </a>
          </p>
        </div>
      </section>
    </>
  );
}
